import type { StudentSummary } from '@/services/api/student-summary';
import { fetchApi } from '@/services/api-client';

export const ADMIN_LATE_ARRIVALS_PATH = '/admin/late-arrivals';

export type LateArrival = {
  id: string;
  studentId: string;
  student: StudentSummary | null;
  submittedByParentId: string | null;
  submittedByParentName: string | null;
  /** The staff member who recorded it, or null when the family filed it themselves. */
  recordedByStaffId: string | null;
  arrivalDate: string;
  arrivalTime: string;
  reason: string;
  createdAt: string;
  excused: boolean;
  excusedChangedAt: string | null;
  termCount: { total: number; notExcused: number };
};

export type AdminCreateLateArrivalData = {
  studentId: string;
  arrivalDate: string;
  arrivalTime: string;
  reason: string;
};

export const adminLateArrivalsApi = {
  list: (params: { studentId?: string } = {}) => {
    const qs = new URLSearchParams();
    if (params.studentId) qs.append('studentId', params.studentId);
    const s = qs.toString();
    return fetchApi<LateArrival[]>(`${ADMIN_LATE_ARRIVALS_PATH}${s ? `?${s}` : ''}`);
  },
  detail: (id: string) => fetchApi<LateArrival>(`${ADMIN_LATE_ARRIVALS_PATH}/${id}`),
  createOnBehalf: (data: AdminCreateLateArrivalData) =>
    fetchApi<LateArrival>(ADMIN_LATE_ARRIVALS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  setExcused: (id: string, excused: boolean) =>
    fetchApi<LateArrival>(`${ADMIN_LATE_ARRIVALS_PATH}/${id}/excused`, {
      method: 'PATCH',
      body: JSON.stringify({ excused }),
    }),
  remove: (id: string) => fetchApi<void>(`${ADMIN_LATE_ARRIVALS_PATH}/${id}`, { method: 'DELETE' }),
};
